<template>
  <b-modal id="withdraw"  centered hide-footer
  @hidden="closeModal"
  >
    <div class="d-flex">
      <div class="warning-wrap withdraw-warning">
        <i class="fa fa-triangle-exclamation" />
      </div>
     <div>
        <h6 class="">Are you sure you want to <b>Withdraw</b> the selected pending item?</h6>
        <p class="light-txt">
          This action is permanent and cannot be undone. The selected members will be removed from the pending list and their status will be updated to "Withdrawn". If you're sure, please confirm your decision.
        </p>
      </div>
    </div>
    <div class="d-flex justify-content-end flex-column-reverse flex-sm-row mt-3 gap-2">
      <b-button variant="secondary" @click="closeModal">Close</b-button>
      <b-button variant="danger" class="univ-btn m-0 px-5 univ-withdraw" @click="submit"
        >Withdraw  </b-button
      >
    </div>
  </b-modal>
</template>
<script>
export default {
  name: "Withdraw",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.$bvModal.show('withdraw');
      } else {
        this.$bvModal.hide('withdraw');
      }
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
      this.$bvModal.hide('withdraw');
    },
    submit() {
      this.$emit('submit');
    },
  },
};
</script>
<style>
.univ-withdraw{
  width: fit-content;
}
.warning-wrap{
    background: rgb(242, 242, 217);
      border-radius: 50px;
  height: fit-content;
  padding: 0.7rem 0.8rem;
  margin-right: 1rem;
}
.withdraw-warning {
  background: rgb(242, 217, 217);
}
.withdraw-warning i {
  color: #dc3545;
}
.warning-wrap i {
  color: #dc8d07;
  font-size: 18px;
}
@media (max-width:576px) {
  .univ-withdraw{
    width: 100%;
    max-width: none;
  }
}
</style>
